import React from 'react';

const TimeCodeDisplay = ({durationFormatted, timePlayedFormatted}) => {
    return (
        <div>{timePlayedFormatted} / {durationFormatted}</div>
    );
};

export default TimeCodeDisplay;
